<template>
    <div class="row">
        <div class="col-12">
            <ListDocuments :documents="getUserDocuments" @loadDocument="loadDocument" @deleteDocument="deleteDocument"/>
            <h4>Editor</h4>
            <form>
                <el-select v-model="selectedDocument" placeholder="Select document">
                    <el-option
                    v-for="item in optionsDocuments"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="selectedLanguage" placeholder="Select language">
                    <el-option
                    v-for="item in getLocalesWithLabels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-button @click="getDocumentWithLanguage">Get default HTML</el-button>
                <p></p>
                <editor 
                    initialEditType="wysiwyg" 
                    :initialValue="editorValue" 
                    :options="editorOptions"
                    @load="onEditorLoad"
                    @focus="onEditorFocus"
                    @blur="onEditorBlur"
                    @change="onEditorChange"
                    @stateChange="onEditorStateChange"
                    ref="toastuiEditor"
                />

                <el-button type="success mt-3 float-right" @click="saveDocument">Save</el-button>
            </form>
        </div>
    </div>
</template>


<script>
  //import 'codemirror/lib/codemirror.css';
  import '@toast-ui/editor/dist/toastui-editor.css';
  import _ from 'underscore';

  import { Editor, Viewer } from '@toast-ui/vue-editor';
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import ListDocuments from './ListDocuments'

  export default {
    components: {
      editor: Editor,
      viewer: Viewer,
      ListDocuments
    },
    data(){
        return { 
            editorValue: "",
            editorOptions: {
                hideModeSwitch: true,
                useCommandShortcut: true,
                useDefaultHTMLSanitizer: true,
                usageStatistics: false,
                language: "en",
                toolbarItems: [
                    'heading',
                    'bold',
                    'italic',
                    'ul',
                    'ol',
                ]
            },
            optionsDocuments: [
                {
                    value: 'terms',
                    label: 'Terms'
                }, 
                {
                    value: 'privacy',
                    label: 'Privacy'
                }
            ],
            selectedDocument: '',
            selectedLanguage: '',
            actualDocument: {
                top: "", 
                end: "",
            },
        }
    },
    methods: {
      ...mapActions([
            'getLocalesAsync',
            'getDefaultLanguage',
            'setDocument',
            'getUserDocumentsAsync',
            'updateDocument',
            'deleteDocumentAsync'
      ]),
      ...mapMutations(['addAlert']),
      onEditorLoad(...args) {
        // implement your code
        //console.log("onEditorLoad: ", {args});
      },
      onEditorFocus(...args) {
          // implement your code
        //console.log("onEditorFocus: ", {args});
      },
      onEditorBlur(...args) {
          // implement your code
        //console.log("onEditorBlur: ", {args});
      },
      onEditorChange(...args) {
          // implement your code
        //console.log("onEditorChange: ", {args});
      },
      onEditorStateChange(...args) {
          // implement your code
        //console.log("onEditorStateChange: ", {args});
      },
      async getDocumentWithLanguage(e){
        e.preventDefault();
        const {data: html} = await this.getDefaultLanguage({document: this.selectedDocument, language: this.selectedLanguage})
        let top = html.slice(0, html.indexOf('<body>') + 6)
        let content = html.slice( html.indexOf('<body>') + 6, html.indexOf('</body>'))
        let end = html.slice( html.indexOf('</body>'), html.indexOf('</html>') + 7)
        this.actualDocument = { top, end }
        this.$refs.toastuiEditor.invoke('setHtml', content);
      },
      saveDocument(e){
        e.preventDefault();
        let html = this.$refs.toastuiEditor.invoke('getHtml');
        const foundObj = _.findWhere(this.getUserDocuments, { document: this.selectedDocument, language: this.selectedLanguage }); 
        
        const { top, end } = this.actualDocument
        if(!this.selectedDocument || !this.selectedLanguage){
            this.addAlert({
                title: 'Failed ',
                type: 'danger',
                body: 'to add document because you dont provide type of document or language'
            });
            return
        }
        if(foundObj === undefined){
            this.setDocument({
                document: this.selectedDocument, 
                language: this.selectedLanguage,
                data: (top + html + end),
                account: this.getUserId
            })

        }else {
            const { document, language, account, objectId} = foundObj
            this.updateDocument({
                document,
                language,
                account,
                objectId,
                data: (top + html + end),
            })
        }

        this.selectedDocument = ''
        this.selectedLanguage = ''
        this.actualDocument = { top: '', end: '' }
        this.$refs.toastuiEditor.invoke('setHtml', '');
      },
      loadDocument({document, language, data}) {
            this.selectedDocument = document
            this.selectedLanguage = language
            let top = data.slice(0, data.indexOf('<body>') + 6)
            let content = data.slice( data.indexOf('<body>') + 6, data.indexOf('</body>'))
            let end = data.slice( data.indexOf('</body>'), data.indexOf('</html>') + 7)
            this.actualDocument = { top, end }
            this.$refs.toastuiEditor.invoke('setHtml', content);
      },
      deleteDocument(doc){
          this.deleteDocumentAsync(doc)
      }
    },
    async created(){
        this.getLocalesAsync()
        this.getUserDocumentsAsync()
    },
    computed: {
        ...mapGetters({
            getLocalesWithLabels: 'getLocalesWithLabels',
            getUserId: 'getUserId', 
            getUserDocuments: 'getUserDocuments'
        }),
    }
  };
</script> 

<style lang="scss">

.tui-editor-contents ol > li::before {
    color: black;
}

.tui-editor-contents ul > li::before{
    background-color: black;
}

.tui-editor-contents h1, .tui-editor-contents h2 {
    border-bottom: none;
}
</style>